import { Link as RLink } from 'react-router-dom';
import { Box, styled } from '@mui/material';

import { colors, devices, zIndex } from '../../styles';

export const FooterWrapper = styled(Box)`
  background-color: ${colors.oliveBlack};
  padding: 60px 16px;
  position: relative;
  z-index: 2;

  @media (${devices.sm}) {
    padding: 60px 120px;
  }

  @media (${devices.lg}) {
    padding: 60px;
  }
`;

export const FooterNavigation = styled('nav')`
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: ${zIndex.layer};

  .logo-wrapper {
    align-items: start;

    img {
      display: block;
      width: 136px;
    }
  }
`;

export const LogoAndNav = styled(Box)`
  display: flex;
  margin-bottom: 0;
  flex-direction: column;
  align-items: center;

  @media (${devices.lg}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
`;

export const LinksWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 42px 42px 70px;

  @media (${devices.lg}) {
    flex-direction: row;
    justify-content: center;
    gap: 26px;
    max-width: 100%;
    margin: 0 24px 70px 24px;
  }
`;

export const Link = styled(RLink)`
  font-size: 18px;
  line-height: 150%;
  font-weight: 500;
  color: ${colors.mainGray};
  text-decoration: none;
  padding: 14px 0;

  &:last-of-type {
    padding-bottom: 28px;
  }

  &:hover {
    color: ${colors.white};
  }

  @media (${devices.lg}) {
    padding: 0 !important;
    line-height: normal;
    margin-bottom: 16px;
    font-size: 14px;
    font-weight: 400;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
`;

export const LinkTitle = styled('h4')`
  margin: 0;
  padding: 28px 0;
  line-height: normal;

  @media (${devices.lg}) {
    padding: 0;
  }

  & > a {
    color: ${colors.white};
    font-size: 18px;
    line-height: 22px;
    font-weight: 500;
    display: block;
    margin: 0;

    @media (${devices.lg}) {
      font-size: 16px;
    }
  }
`;

export const Title = styled('h4')<{ isOpen?: boolean }>`
  margin: 0;
  padding: 28px 0;
  color: ${colors.white};
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  font-weight: 500;
  line-height: normal;

  @media (${devices.lg}) {
    padding: 0;
    font-size: 16px;
  }

  img {
    width: 24px;
    height: 24px;
    transition: transform 0.3s ease;
    transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  }
`;

export const LinksSection = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const LinksSectionPlatform = styled(LinksSection)`
  display: block;
  order: 0;

  h4 {
    margin-bottom: 0;

    @media (${devices.lg}) {
      margin-bottom: 16px;
    }

    a {
      margin: 0;
    }
  }

  a {
    display: block;
  }
`;

export const LinksSectionIndustries = styled(LinksSection)`
  display: block;
  order: 1;
  border-bottom: 1px solid ${colors.brandLightGrey};
  border-top: 1px solid ${colors.brandLightGrey};

  @media (${devices.sm}) {
    min-width: auto;
    display: block;
  }

  @media (${devices.lg}) {
    border-bottom: none;
    border-top: none;
    padding: 0 18px;
    border-left: 1px solid ${colors.brandLightGrey};
  }

  h4 {
    margin-bottom: 0;

    @media (${devices.lg}) {
      margin-bottom: 16px;
    }

    a {
      margin: 0;
    }
  }

  a {
    display: block;
  }
`;

export const LinksSectionApplications = styled(LinksSection)`
  display: block;
  order: 2;
  border-bottom: 1px solid ${colors.brandLightGrey};

  @media (${devices.sm}) {
    min-width: auto;
    display: block;
  }

  @media (${devices.lg}) {
    border-bottom: none;
    padding: 0 18px;
    border-left: 1px solid ${colors.brandLightGrey};
  }

  h4 {
    margin-bottom: 0;

    @media (${devices.lg}) {
      margin-bottom: 16px;
    }

    a {
      margin: 0;
    }
  }

  a {
    display: block;
  }
`;

export const LinksSectionCompany = styled(LinksSection)`
  order: 3;
  border-bottom: 1px solid ${colors.brandLightGrey};

  @media (${devices.sm}) {
    min-width: auto;
    display: block;
  }

  @media (${devices.lg}) {
    border-bottom: none;
    padding: 0 18px;
    border-left: 1px solid ${colors.brandLightGrey};
  }

  h4 {
    margin-bottom: 0;

    @media (${devices.lg}) {
      margin-bottom: 16px;
    }

    a {
      margin: 0;
    }
  }

  a {
    display: block;
  }
`;

export const LinksSectionResources = styled(LinksSection)`
  display: block;
  order: 4;

  @media (${devices.lg}) {
    padding: 0 18px;
    border-left: 1px solid ${colors.brandLightGrey};
  }

  a {
    padding: 0 !important;
  }
`;

export const SubpageList = styled(Box)`
  @media (${devices.sm}) {
    display: flex;
    flex-direction: column;
  }
`;

export const PrivacyLink = styled('span')`
  text-decoration: none;
  cursor: pointer;
  color: inherit;
  display: inline-block;
`;

export const SubText = styled('div')`
  display: flex;
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  line-height: 15px;

  a {
    cursor: pointer;
    color: inherit;
    padding: 0 !important;
  }
`;

export const SocialMediaBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  opacity: 0.8;

  img {
    display: block;
  }
`;

export const CopyrightInfo = styled(Box)`
  display: flex;
  color: ${colors.mainGray};
  flex-direction: column;
  align-items: center;

  width: 100%;

  @media (${devices.lg}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const InfoLink = styled('a')({
  fontSize: '12px',
  lineHeight: '100%',
  textAlign: 'center',
  textDecoration: 'underline',
  color: '#FFFFFFCC',
});
